import React from 'react';
import { IconProps } from '.';

const SvgUpload = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='m12 8.94 4.03 4.03-1.06 1.06-2.22-2.22v7.69h-1.5v-7.69l-2.22 2.22-1.06-1.06L12 8.94Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 4.75a6.09 6.09 0 0 0-3.796 1.277c-1.113.845-1.853 1.944-2.23 3.321l-.12.437-.442.097a4.438 4.438 0 0 0-2.647 1.675A4.829 4.829 0 0 0 1.75 14.58c0 1.313.456 2.403 1.384 3.314.931.907 2.039 1.356 3.366 1.356h12c1.058 0 1.93-.36 2.66-1.09.73-.73 1.09-1.602 1.09-2.66 0-.963-.313-1.786-.95-2.501l-.006-.007c-.63-.724-1.41-1.135-2.38-1.247l-.664-.077V11c0-1.758-.603-3.219-1.819-4.428l-.003-.003C15.218 5.353 13.758 4.75 12 4.75Zm-4.704.083A7.59 7.59 0 0 1 12 3.25c2.148 0 3.994.756 5.49 2.26 1.354 1.347 2.102 2.977 2.237 4.856a5.032 5.032 0 0 1 2.696 1.639A5.116 5.116 0 0 1 23.75 15.5c0 1.449-.513 2.704-1.53 3.72-1.016 1.017-2.271 1.53-3.72 1.53h-12c-1.713 0-3.198-.598-4.414-1.783l-.001-.002C.867 17.77.25 16.293.25 14.58c0-1.463.443-2.783 1.324-3.936l.002-.002a5.909 5.909 0 0 1 3.078-2.113 7.51 7.51 0 0 1 2.642-3.696Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgUpload;
